import useGetAccessToken from 'components/Dashboard/apiCalls/useGetAccessToken';
import useOrganizationInfoDescriptionFunctions from 'components/Dashboard/hooks/useOrganizationInfoDescriptionFunctions';
import { consultantAgenciesMembers } from 'components/Dashboard/SidebarElements/parliamentarianUsers';
import GenerateDescriptionComponent from 'components/Login/CreateProfile/GenerateDescriptionComponent';
import getActivePlan from 'components/Settings/Utilities/getActivePlan';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import getAppSite from 'utils/getAppSite';

const CreateProfileGenerateOrganisationDescription = () => {
  const { updateOrganizationInfoDescription } = useOrganizationInfoDescriptionFunctions();
  const { getAccessToken } = useGetAccessToken();

  const [isLoadingPlan, setIsLoadingPlan] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [clientDescription, setClientDescription] = useState('');
  const [isLoadingSaveDescription, setIsLoadingSaveDescription] = useState(false);
  const navigate = useNavigate();

  const checkIfAgency = useRef(null);
  checkIfAgency.current = async (source) => {
    const activePlan = await getActivePlan(getAccessToken, source);
    if (source.signal.aborted) return;
    if (consultantAgenciesMembers(activePlan?.code) && activePlan?.allowMultipleTeams) {
      navigate('/create-your-profile/3', { replace: true });
    } else {
      setIsLoadingPlan(false);
    }
  };

  useEffect(() => {
    const source = new AbortController();
    checkIfAgency.current(source);
    return () => source.abort('Component unmounted.');
  }, []);

  const saveDescription = async () => {
    try {
      setIsLoadingSaveDescription(true);
      await updateOrganizationInfoDescription({ value: clientDescription });
      navigate({ pathname: `/create-your-profile/3` });
    } catch (error) {
      setIsLoadingSaveDescription(false);
    }
  };
  const isUsa = getAppSite() === 'usa';

  return (
    <>
      <h2 className='mb-2'>{isUsa ? 'Organization' : 'Organisation'} description</h2>
      <p className='mb-4'>
        PolicyMogul {isUsa ? 'summarizes' : 'summarises'} key political developments for you. In order to tailor them,
        we require an {isUsa ? 'organization' : 'organisation'} description. Please review what we have generated for
        you.{' '}
      </p>
      {isLoadingPlan ? (
        <div className='border rounded p-4' style={{ minHeight: '150px' }}>
          <SkeletonTheme baseColor='#f2f2f2'>
            <Skeleton height={20} width={'100%'} />
          </SkeletonTheme>
        </div>
      ) : (
        <GenerateDescriptionComponent
          clientDescriptionState={{ clientDescription, setClientDescription }}
          loadingState={{ isLoading, setIsLoading }}
        />
      )}
      <div className='flex-centered'>
        <button
          className={`btn btn-general action-button pl-3 py-1 my-4`}
          disabled={isLoading || clientDescription?.length < 100 || isLoadingSaveDescription}
          onClick={saveDescription}
        >
          {isLoadingSaveDescription ? (
            <i className='fas fa-spinner fa-spin d-inline-block-centered mr-2' />
          ) : (
            <>
              Next <span style={{ fontSize: '10px' }} className='icon-long-arrow-right d-inline-block-centered ml-2' />
            </>
          )}
        </button>
      </div>
    </>
  );
};

export default CreateProfileGenerateOrganisationDescription;
